module.exports = __webpack_public_path__ + "img/kj_icon2.6eb4f683.png";